// modules
import React from 'react';
// components
import { TableCell, TableRow } from '@upstox/upstox-ui';
// styles
import * as css from './styles';

const StrikesTableHeader = () => (
  <TableRow>
    <TableCell css={css.headerCell}>
      Strike Price
    </TableCell>
  </TableRow>
);

export default StrikesTableHeader;
